import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

export { ActiveBrandService } from './active-brand.service';

import { ActiveBrandService } from './active-brand.service';

export const ngxActiveBrandServiceModule = angular.module('ngxActiveBrandServiceModule', [])
	.factory('activeBrand', downgradeInjectable(ActiveBrandService) as any)
	.name;
